import { apiSlice } from '../app/api/apiSlice';
import { setPlatformsList, setPlatformsNames, updatePlatforms } from '../store/slices/platforms/platforms';
import queryString from 'query-string';

export const platformsApi = apiSlice.injectEndpoints({
  endpoints: (builder)=>({
    getPlatformNames: builder.query({
      keepUnusedDataFor: 120,
      query: () => 'platform',
      // every time the query is dispatched, this function will be called
      // so we can set the state on the store here instead of in the component
      async onQueryStarted(queryArg, { dispatch, queryFulfilled }) {
        // `onStart` side-effect
        console.log('getPlatformNames, start...')
        try {
          const { data } = await queryFulfilled
          // `onSuccess` side-effect
          console.log('getPlatformNames, success: ', data)
          dispatch(setPlatformsNames(data))
        } catch (err) {
          // `onError` side-effect
          if (err.error?.originalStatus === 401) {
            // baseQueryWithReauth will handle the 401 error
            return
          }
          console.log('getPlatformNames, error: ', err)
          throw err
        }
      }
    }),
    getPlatforms : builder.query({
      keepUnusedDataFor: 60,
      query: () => '/Credential/platforms',
      // every time the query is dispatched, this function will be called
      // so we can set the state on the store here instead of in the component
      async onQueryStarted(queryArg, { dispatch, queryFulfilled }) {
        // `onStart` side-effect
        console.log('getPlatformsCredentials, start...')
        try {
          const { data } = await queryFulfilled
          // `onSuccess` side-effect
          console.log('getPlatformsCredentials, success: ', data)
          dispatch(setPlatformsList(data))
        } catch (err) {
          // `onError` side-effect
          if (err.error?.originalStatus === 401) {
            // baseQueryWithReauth will handle the 401 error
            return
          }
          console.log('getPlatformsCredentials, error: ', err)
          throw err
        }
      }
    }),
    //TODO: This is not okay, we are exposing our decrypted password to the client
    getPlatformsForUser : builder.query({
      keepUnusedDataFor: 60,
      query: (userId) => '/Credential/platforms?userId=' + userId,
      // every time the query is dispatched, this function will be called
      // so we can set the state on the store here instead of in the component
      async onQueryStarted(queryArg, { dispatch, queryFulfilled }) {
        // `onStart` side-effect
        console.log('getPlatformsCredentialsForUser, started...')
        try {
          const { data } = await queryFulfilled
          // `onSuccess` side-effect
          console.log('getPlatformsCredentialsForUser, success: ', data)
          dispatch(updatePlatforms(data))
        } catch (err) {
          // `onError` side-effect
          if (err.error?.originalStatus === 401) {
            // baseQueryWithReauth will handle the 401 error
            return
          }
          console.log('getPlatformsCredentialsForUser, error: ', err)
          throw err
        }
      }
    }),
    deletePlatform : builder.mutation({
      query: (platformId) => ({
        url:`/Credential/${platformId}`,
        method: 'DELETE'
      }),
    }), 
    decryptPlatformPassword: builder.mutation({
      query: (platformId) => ({
        url: `/credential/decrypt/${platformId}`,
        method: 'GET',
      }),
    }),
    decryptMultiplePlatformsPasswords: builder.query({
      query: (query) => ({
        url: `/credential/decrypt/platforms${query ? query : ''}`,
        provideTags: ['PlatformsUncryptedCredentials'],
        keepUnusedDataFor: 60,
      }),
    }),
  })
})

export const { useGetPlatformNamesQuery, useLazyGetPlatformsForUserQuery,useLazyGetPlatformNamesQuery, useGetPlatformsQuery, useDeletePlatformMutation, useDecryptPlatformPasswordMutation, useDecryptMultiplePlatformPasswordMutation, useLazyDecryptMultiplePlatformsPasswordsQuery } = platformsApi;
